export default {
    metamaskDownloadURL: "https://metamask.io/download/",
    authTimeout: 12 * 60 * 60 * 1000, //in millisecond
    paymentCoinDecimal: 6
}